import React from 'react';
import { Box } from '@mui/material';
import RodoClause from './components/RodoClause';
import SiteFooter from './components/SiteFooter';

const RodoPage = () => (
  <Box sx={{ minHeight: '100vh', backgroundColor: '#fafafa' }}>
    <RodoClause id="rodo-clause" />
    <SiteFooter />
  </Box>
);

export default RodoPage;
